<template>
  <div
    class="text"
    :class="[colorClass, sizeClass, fontStyleClass]">
    <slot/>
  </div>
</template>
<script>
export default {
  name: 'BaseText',
  props: {
    size: {
      type: String,
      default: '1'
    },
    color: {
      type: String,
      default: null
    },
    fontStyle: {
      type: String,
      default: null
    }
  },
  computed: {
    colorClass () {
      return (this.color ? 'text--color-' + this.color : '')
    },
    sizeClass () {
      return (this.size ? `text--size-${this.size}` : '')
    },
    fontStyleClass () {
      return (this.fontStyle ? `text--style-${this.fontStyle}` : '')
    }
  }
}
</script>
<style lang="scss" scoped>
  @import './base-text'
</style>



// WEBPACK FOOTER //
// src/components/BaseText/BaseText.vue